export function createRoutes() {
  return [
    {
      path: 'live',
      component: () => import(/* webpackChunkName: "LiveChrome" */ './LiveChrome.vue'),
      children: [
        {
          path: '/',
          name: 'liveList',
          component: () => import(/* webpackChunkName: "LiveList" */ './LiveList.vue'),
        },
        {
          path: 'create',
          components: {
            default: () => import(/* webpackChunkName: "LiveList" */ './LiveList.vue'),
            dialog: () => import(/* webpackChunkName: "ManageLiveSourceModal" */ './ManageLiveSourceModal.vue'),
          },
        },
        {
          path: ':liveId',
          name: 'liveEdit',
          component: () => import(/* webpackChunkName: "VideoList" */ './LiveEdit.vue'),
        },
        // {
        //   path: 'import',
        //   components: {
        //     default: () => import(/* webpackChunkName: "VideoList" */ './VideoList.vue'),
        //     dialog: () => import(/* webpackChunkName: "VideoEditChrome" */ './ImportVideoModal.vue'),
        //   },
        // },
        // {
        //   path: ':videoId',
        //   component: () => import(/* webpackChunkName: "VideoEditChrome" */ '@/video/VideoEdit.vue'),
        // },
      ],
    },
  ];
}

export default {
  createRoutes,
};
